import { render, staticRenderFns } from "./EndingArticle.vue?vue&type=template&id=5c3c170e&"
import script from "./EndingArticle.vue?vue&type=script&lang=js&"
export * from "./EndingArticle.vue?vue&type=script&lang=js&"
import style0 from "./EndingArticle.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports